import { render } from "./DeathOverview.vue?vue&type=template&id=04cb02c6&scoped=true"
import script from "./DeathOverview.vue?vue&type=script&lang=js"
export * from "./DeathOverview.vue?vue&type=script&lang=js"

import "./DeathOverview.vue?vue&type=style&index=0&id=04cb02c6&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cb02c6"]])

export default __exports__